import Superagent from 'superagent'
import Storage from './storage.service'

const { HOST_API } = _CONSTANTS_

export default {
    getCharges,
    getChargesTotal,
    getChargesShipment,
    downloadCharges,
    uploadCharges,
    getChargeImports,
    getChargeImport,
    deleteCharge,
    approveCharge,
    updateCharge,
    createCharge
}

function getCharges(query = {}) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/charges`)
           .set('access', Storage.getItem('access'))
           .query(query)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getChargesTotal(userId) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/charges/total`)
           .set('access', Storage.getItem('access'))
           .query(userId ? { userId } : {})
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function getChargesShipment(shipmentId) {
    return new Promise((resolve, reject) => {
        Superagent
           .get(`${HOST_API}/charges/shipment/${shipmentId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function downloadCharges(query) {
    return new Promise((resolve, reject) => {
        Superagent
            .post(`${HOST_API}/charges/download`)
            .set('access', Storage.getItem('access'))
            .query({admin: true})
            .send(query)
            .responseType('blob')
            .end((err, res) => {
                if(err)
                    resolve(null)
                else
                    resolve(res.body)
            })
    })
}

function uploadCharges(data) {
    return new Promise((resolve, reject) => {
        const request = Superagent
           .post(`${HOST_API}/charges/upload`)
           .set('access', Storage.getItem('access'))
           .attach('chargesFile', data.chargesFile)
           .field('partner', data.partner || '')

        if(data.invoice)
            request.field('invoice', data.invoice)

        if(data.applyCharges)
            request.field('applyCharges', true)

        const preview = data.partner === 'FedEx' || data.partner === 'skydropx' || data.partner === 't1envios' || data.partner === 'drenvio'

        if(!preview)
            request.responseType('blob')

        request.end((err, res) => {
            if(preview)
                return resolve(err || !res ? { success: false, error: { message: 'Error al revisar el archivo' } } : res.body)

            if(err)
                resolve(null)
            else
                resolve(res.body)
        })
    })
}

function getChargeImports() {
    return new Promise((resolve) => {
        Superagent
           .get(`${HOST_API}/charges/imports`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res?.body || { success: false, error: { message: 'Error al obtener los archivos' } })
           })
    })
}

function getChargeImport(importId) {
    return new Promise((resolve) => {
        Superagent
           .get(`${HOST_API}/charges/imports/${importId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res?.body || { success: false, error: { message: 'Error al obtener el detalle' } })
           })
    })
}

function deleteCharge(chargeId) {
    return new Promise((resolve, reject) => {
        Superagent
           .delete(`${HOST_API}/charges/${chargeId}`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function updateCharge(chargeId, data) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/charges/${chargeId}`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function approveCharge(chargeId) {
    return new Promise((resolve, reject) => {
        Superagent
           .put(`${HOST_API}/charges/${chargeId}/approve`)
           .set('access', Storage.getItem('access'))
           .end((err, res) => {
               resolve(res.body)
           })
    })
}

function createCharge(data) {
    return new Promise((resolve, reject) => {
        Superagent
           .post(`${HOST_API}/charges`)
           .set('access', Storage.getItem('access'))
           .send(data)
           .end((err, res) => {
               resolve(res.body)
           })
    })
}